<template>
  <el-switch v-bind="$attrs" :size="sizeMap[props.size]" :class="[style.switch, `switch-${props.size}`]">
    <slot />
  </el-switch>
</template>

<script setup lang="ts">
const props = defineProps({
  size: {
    validator(value: string) {
      return ['max', 'large', 'default', 'small'].indexOf(value) > -1;
    },
    type: String,
    default: 'default'
  }
});

const sizeMap: any = reactive({
  max: 'large',
  large: 'large',
  default: 'default',
  small: 'small',
  mini: 'small'
});

</script>

<style lang="scss" module="style">
.switch {
  --el-switch-on-color: var(--primary-primary3);
  --el-switch-off-color: var(--gray-gray2);
  --el-color-white: var(--text-text0);

  &:global {
    &.is-disabled {
      opacity: 1;
      --el-switch-on-color: var(--primary-primary4);
      --el-switch-off-color: var(--gray-gray2);
      --el-color-white: var(--text-text5);
    }
  }

  &:global{
    &.is-disabled.is-checked {
      --el-color-white: var(--text-text0);
    }
  }
}
</style>
